module.exports = __webpack_public_path__ + "img/7fe6e42.jpg";